import * as Auth0 from 'auth0-js';
import { Environment } from 'global/environment';

export const auth0 = new Auth0.Authentication({
  domain: Environment.AUTH0_DOMAIN,
  clientID: Environment.AUTH0_CLIENT,
  audience: Environment.AUTH0_AUDIENCE,
});
